import "./index.css";
import { createRoot } from "react-dom/client";
import { useState, useCallback } from "react";
import { ChatContainer } from "./core/chat/ChatContainer";
import { MessageCircle } from "lucide-react";
import { LanguageProvider } from "./contexts/LanguageContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 60_000,
    },
    mutations: {
      retry: 0,
    },
  },
});

function initMain(element: HTMLElement) {
  const root = createRoot(element);
  root.render(
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <MainComponent />
      </LanguageProvider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </QueryClientProvider>
  );
}

window.addEventListener("DOMContentLoaded", () => {
  const elementHost = document.getElementById("agent-ui-host");
  if (elementHost) {
    initMain(elementHost);
  }
});

function MainComponent() {
  const [visible, setVisible] = useState(true);
  const handleClose = useCallback(() => setVisible(false), []);

  return (
    <div className="fixed bottom-4 right-4 z-50">
      {visible ? (
        <div className="w-[650px] h-[600px] max-w-full">
          <ChatContainer onClose={handleClose} />
        </div>
      ) : (
        <button
          onClick={() => setVisible(true)}
          className="w-14 h-14 bg-orange-500 hover:bg-orange-600 rounded-full shadow-lg flex items-center justify-center"
          aria-label="Open chat"
        >
           <MessageCircle className="h-6 w-6" />
        </button>
      )}
    </div>
  );
}
